import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api'
import { entrarComBiometria } from './utils/biometria'
import { reiniciarAvisoMensalidade } from './utils/avisoMensalidade'
import { reiniciarNotificacoes } from './utils/notificacoes'
const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(
    JSON.parse(localStorage.getItem('isAuthenticated')) || false
  );

  const [userLogado, setUserLogado] = useState(  JSON.parse(localStorage.getItem('user')) || {nome:''});
  const [token, setToken] = useState(  JSON.parse(localStorage.getItem('token')) || '');
  

 

  const login = async (user, password) => {
    // Lógica de autenticação aqui
    // Quando o login for bem-sucedido, chame setIsAuthenticated(true)

    try {

        const body ={
            email: user,
            password: password
        }
       
        const response = await api.post('v2/sessions', body); // /sessions é do web antigo (pode ser bloqueada)
        reiniciarAvisoMensalidade(); // cada login mostra de novo o aviso de mensalidade em aberto
        setIsAuthenticated(response.data.auth);
        setUserLogado(response.data.user);
        setToken(response.data.token)

        // api.defaults.headers.Authorization = `Bearer ${token}`;
       
        
        return({isAuthenticated:response.data.auth, message:''})
      } catch (error) {
        console.error('Erro ao logar', error);
       
        return({isAuthenticated:false, message:error.response?.data?.erro || 'Não foi possível entrar. Tente novamente.'})
      }
    
  };

  // Login com a biometria do aparelho (WebAuthn); a API devolve a mesma sessão do login por senha.
  const loginBiometria = async () => {
    const resultado = await entrarComBiometria();
    if (!resultado.ok) return { isAuthenticated: false, message: resultado.message };
    reiniciarAvisoMensalidade();
    setIsAuthenticated(resultado.sessao.auth);
    setUserLogado(resultado.sessao.user);
    setToken(resultado.sessao.token);
    return { isAuthenticated: true, message: '' };
  };

  // Login de árbitro ou goleiro (coleções próprias na API).
  const loginEquipe = async (papel, login, password) => {
    try {
      const response = await api.post(`${papel}/sessions`, { login, password });
      setIsAuthenticated(true);
      setUserLogado(response.data.user);
      setToken(response.data.token);
      return { isAuthenticated: true, message: '' };
    } catch (error) {
      return { isAuthenticated: false, message: error.response?.data?.erro || 'Não foi possível entrar.' };
    }
  };
  const loginArbitro = (login, password) => loginEquipe('arbitro', login, password);
  const loginGoleiro = (login, password) => loginEquipe('goleiro', login, password);

  // Atualiza os dados do usuário logado (ex.: após editar perfil ou foto).
  const updateUser = (user) => {
    setUserLogado((atual) => ({ ...atual, ...user }));
  };

  const logout = () => {
    try { sessionStorage.removeItem('rfc_redirect_pelada_verificado'); } catch (e) { /* ignore */ }
    reiniciarAvisoMensalidade(); // no próximo login o aviso de mensalidade em aberto volta a aparecer
    reiniciarNotificacoes();
    // Lógica para fazer logout
    setIsAuthenticated(false);
    // console.log("setou false");
  };

  useEffect(() => {
    if (isAuthenticated) {
        console.log("auteticado")
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 2); // Expire após dois dias

      const authData = {
        expirationDate: expirationDate.toISOString(),
      };

      localStorage.setItem('authData', JSON.stringify(authData));
      localStorage.setItem('isAuthenticated', JSON.stringify(isAuthenticated));
      localStorage.setItem('token', JSON.stringify(token));
      localStorage.setItem('user', JSON.stringify(userLogado));
      // api.api.defaults.headers.Authorization = `Bearer ${token}`;
    } else {
        console.log("removendo login")
      localStorage.removeItem('authData');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    //   setUserLogado({});
    }
  }, [isAuthenticated, userLogado,token]);

  useEffect(() => {
    const authData = JSON.parse(localStorage.getItem('authData'));
    if (authData && new Date(authData.expirationDate) < new Date()) {
        console.log(authData);
        setIsAuthenticated(false)
        setUserLogado({ nome: '' });
        setToken('')
      } 
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, loginBiometria, loginArbitro, loginGoleiro, logout, userLogado, token, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
